module.exports = __webpack_public_path__ + "img/plusvalia.25cdb7d1.png";